export var contentVariantMap = {
  l: 'body-paragraph-large',
  s: 'body-paragraph-small'
};
export var labelVariantMap = {
  l: 'display-small',
  s: 'display-extrasmall'
};